function resetStoreState(state, defaultState, excludes = []) {
    for (const key in state) {
        restoreStoreItem(state, defaultState, key, "", excludes);
    }
}

function restoreStoreItem(state, defaultState, key, path, excludes) {
    if (excludes.includes(path + key)) {
        return;
    }

    // if we have no default for the item make sure to remove it
    if (!defaultState.hasOwnProperty(key)) {
        delete state[key];
        return;
    }

    const stateItem = state[key];
    const defaultStateItem = defaultState[key];

    if (stateItem && stateItem.constructor === Object && defaultStateItem) {
        for (const itemKey in stateItem) {
            restoreStoreItem(state[key], defaultState[key], itemKey, path + key + ".", excludes);
        }
    } else {
        state[key] = defaultState[key];
    }
}

export {
    resetStoreState
}